// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "DoDontRow-module--bx--text-truncate--end---aoa5";
export var bxTextTruncateFront = "DoDontRow-module--bx--text-truncate--front--KKlcY";
export var caption = "DoDontRow-module--caption--8tP-9";
export var card = "DoDontRow-module--card--gsy5L";
export var cardContent = "DoDontRow-module--card-content--zcOTw";
export var content = "DoDontRow-module--content--19hru";
export var correct = "DoDontRow-module--correct--9u6kZ";
export var dark = "DoDontRow-module--dark--R+ZM0";
export var description = "DoDontRow-module--description--e25Jc";
export var doDontRow = "DoDontRow-module--do-dont-row--mujVf";
export var example = "DoDontRow-module--example--5rglf";
export var icon = "DoDontRow-module--icon--cpmT4";
export var iconCorrect = "DoDontRow-module--icon-correct--HJ+jr";
export var iconIncorrect = "DoDontRow-module--icon-incorrect--8cdld";
export var image = "DoDontRow-module--image--+FUfz";
export var incorrect = "DoDontRow-module--incorrect--HPgl1";
export var ratio = "DoDontRow-module--ratio--Bu-YQ";
export var ratio16x9 = "DoDontRow-module--ratio16x9--nLvix";
export var ratio1x1 = "DoDontRow-module--ratio1x1--GdxKQ";
export var ratio1x2 = "DoDontRow-module--ratio1x2--I5XBa";
export var ratio2x1 = "DoDontRow-module--ratio2x1--cCJ7l";
export var ratio3x4 = "DoDontRow-module--ratio3x4--kmLWJ";
export var ratio4x3 = "DoDontRow-module--ratio4x3--mmq3u";
export var ratio9x16 = "DoDontRow-module--ratio9x16--0yxa+";
export var text = "DoDontRow-module--text--mzVhx";
export var title = "DoDontRow-module--title--gjKmx";